/**
 * MSAL (Microsoft Authentication Library) Configuration
 * Configure Azure AD authentication settings
 */
import { Configuration, PopupRequest } from '@azure/msal-browser';

// Get Azure AD configuration from environment variables
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/auth/callback`;

// Validate required configuration
if (!clientId || !tenantId) {
  console.error(
    'Azure AD configuration is missing. Please set the following environment variables:\n' +
    '  REACT_APP_AZURE_CLIENT_ID\n' +
    '  REACT_APP_AZURE_TENANT_ID\n' +
    '  REACT_APP_AZURE_REDIRECT_URI (optional, defaults to current origin)\n\n' +
    'Create a .env file in the frontend directory with these variables.\n' +
    'See sso/ENVIRONMENT_VARIABLES.md for setup instructions.'
  );
}

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : 'https://login.microsoftonline.com/common',
    redirectUri: redirectUri,
    // /auth/callback owns handleRedirectPromise() and the final app navigation.
    // Prevent MSAL from navigating away before that callback can exchange the ID token.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Check if Azure AD is properly configured
export const isSSOConfigured = (): boolean => {
  return !!(clientId && tenantId);
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints and scopes when obtaining an access token for protected web APIs.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
